var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginKakao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#coi074y4fa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.648 25.62s1.88.197 2.853.197c9.035 0 16.361-5.779 16.361-12.909C32.862 5.778 25.536 0 16.501 0 7.465 0 .139 5.78.139 12.908c0 4.42 2.814 8.319 7.107 10.647 0 0-.58 3.088-3.824 6.046 0 0-.32.564.642.354.963-.21 6.945-2.323 9.584-4.333v-.001z",
    fill: "#493236"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "coi074y4fa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.14)",
    d: "M0 0h32.722v30H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginKakao);
export default __webpack_public_path__ + "static/media/loginKakao.7d481cda7ee77fdc2d6455ca513e0ae8.svg";
export { ForwardRef as ReactComponent };